<div class="cellRows row border">
  <div class="cellValues col-md-3">{{item?.name}}</div>
  <!-- <div class="cellValues text-center">{{item?.mfg_date | date:'dd-MM-yyyy'}}</div>-->
  <div class="cellValues text-center col-md-2">{{item?.manufacturer }}</div>
  <!-- <div class="cellValues text-center col-md-1">{{item?.price| currency : 'INR' : 'symbol-narrow' : '1.2-2'}}</div> -->
  <div class="cellValues text-center col-md-1" *ngIf="item.category !== 'OTHERS'">{{item?.qty}}</div>
  <div class="cellValues text-center col-md-2"><span>{{item?.threshold_qty | number : '1.0-2' }}</span><em
      class="fa fa-pencil smallEdit" (click)="editThreshValues(item)"></em></div>
  <div class="cellValues text-center col-md-2">{{item?.category}}</div>
  <!-- <div class="cellValues text-center col-md-1">{{item?.batches.length}}</div> -->
  <div class="cellValues text-center col-md-2">
    <!-- <em class="fa fa-plus text-info" (click)="addNewBatch(item)" title="Add Batch"></em> -->
    <em class="fa ml-2 fa-pencil-square-o editIcon" (click)="editValues(item)"></em>
    <em class="fa fa-times-circle ml-3 deleteIcon" (click)="openDeleteConfirmationDialog(item,'item')"></em>
    <em class="fa downIcon float-right" [ngClass]="{'fa-chevron-up':open, 'fa-chevron-down':!open}"
      title="Batch Details" (click)="openItem(item)"></em>
  </div>
  <ng-container *ngIf="batches && batches.length > 0 && open">
    <div class="col-md-12 table table-hover inventoryTable table-bordered">
      <div class="cellRows row border" *ngFor="let batchItem of batches; let index=index">
        <span class="cellValues subLevel col-md-2">Batch ID: {{batchItem?.batchId}}</span>
        <!-- <span class="cellValues subLevel col-md-1">Batch No: {{batchItem?.batch_no}}</span> -->
        <span class="cellValues subLevel col-md-1">Qty: {{batchItem?.qty}}</span>
        <span class="cellValues subLevel col-md-2">
          Purchase Price: {{batchItem?.buying_price| currency : 'INR' : 'symbol-narrow' : '1.2-2'}}
        </span>
        <span class="cellValues subLevel text-center col-md-2">
          Selling Price: {{batchItem?.selling_price| currency : 'INR' : 'symbol-narrow' : '1.2-2'}}
        </span>
        <span class="cellValues subLevel col-md-2">Exp Date: {{batchItem?.expiry_date | date:'dd-MM-yyyy'}}
        </span>
        <span class="cellValues subLevel category col-md-2">Rack No: {{batchItem?.rack_no}}</span>
        <span class="cellValues subLevel col-md-1 p-0">
          <em class="fa fa-pencil-square-o editIcon" (click)="editBatchValues(batchItem,item)"></em>
          <em class="fa fa-times-circle ml-3 deleteIcon"
            (click)="openDeleteConfirmationDialog(batchItem,'batch',item._id)"></em>
        </span>
      </div>
    </div>
    <div class="col-md-12 bg-white">
      <div class="ml-2">Instruction: {{item?.instructions}}</div>
      <div class="ml-2">Supplier Name: {{item?.supplier}}</div>
    </div>
  </ng-container>
</div>
